// Renders the enrollment_letter_received tri-state (1/0/null) as a colored
// Yes/No badge. `value` may be the raw DB value (1, 0, null) or its string
// form ("1", "0", ""). `nullLabel` controls how the unset state is shown
// (defaults to "—"; pass e.g. "Not Set" for a clearer label where a bare
// dash would be ambiguous).
export default function EnrollmentStatusBadge({ value, nullLabel = "—" }) {
  const normalized =
    value === null || value === undefined || value === "" ? "" : String(Number(value));

  if (normalized === "1")
    return (
      <span className="inline-block px-2 py-1 bg-green-100 text-green-700 rounded-full text-xs font-semibold">
        Yes
      </span>
    );
  if (normalized === "0")
    return (
      <span className="inline-block px-2 py-1 bg-red-100 text-red-700 rounded-full text-xs font-semibold">
        No
      </span>
    );
  return <span className="text-gray-400 text-xs">{nullLabel}</span>;
}
